import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const BrandModelCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Group gap={0}>
                <Text fw={'bold'}>{rowData.brand}</Text>
                <Text ms={4}>- {rowData.model}</Text>
            </Group>
        </Box>
    );
};

const BrandModelColumn = () => ({
    accessorKey: 'brand',
    header: 'Brand / Model',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <BrandModelCell cell={cell} />,
});
export default BrandModelColumn;
